import { render, staticRenderFns } from "./WeedoTrustCalculatorAf.vue?vue&type=template&id=ef586c86&scoped=true&"
import script from "./WeedoTrustCalculatorAf.vue?vue&type=script&lang=js&"
export * from "./WeedoTrustCalculatorAf.vue?vue&type=script&lang=js&"
import style0 from "./WeedoTrustCalculatorAf.vue?vue&type=style&index=0&id=ef586c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef586c86",
  null
  
)

export default component.exports